<template>
  <div class="Inspiration-filter">
    <ux-atoms-button
      :aria-controls="id"
      :aria-expanded="filterModalIsOpen"
      :class="['Inspiration-filter__button', { 'Inspiration-filter__button--has-filters': selectedFilters }]"
      @click="filterButtonAction"
      aria-haspopup="true"
      size="l"
    >
      {{ label }}
      <ux-atoms-chip
        :aria-label="$t('ux.molecules.inspirationFilter.filtersNumber', { n: selectedFilters })"
        :label="selectedFilters"
        class="Inspiration-filter__button-chip"
        v-if="selectedFilters"
      />
      <ux-atoms-icon
        :class="['Inspiration-filter__button-icon', { 'Inspiration-filter__button-icon--reversed': filterModalIsOpen }]"
        name="chevron-down"
        size="m"
      />
    </ux-atoms-button>

    <client-only>
      <Teleport to="#teleports" v-if="!isTablet">
        <ux-molecules-modal
          :event-element="modalTarget"
          :id="id"
          button-no-border
          button-position="right"
          has-content-full-height
          has-label-id
          has-no-separator
          has-top-gap
          no-y-space
          size="medium"
          v-model="filterModalIsOpen"
        >
          <template #header>
            <ux-atoms-typo :text="label" as="p" class="Inspiration-filter__modal-title" color="dark" variant="expressive-heading-06" />
          </template>
          <ux-molecules-inspiration-filter-content
            :filters="filters"
            :legend="filtersTitle"
            @inspiration-filter-content::filter-update="filterUpdate"
          />
        </ux-molecules-modal>
      </Teleport>
      <ux-molecules-modal-dropdown
        :event-element="modalTarget"
        :id="id"
        :model-value="filterModalIsOpen"
        @modal-dropdown:model-value="closeFilterModal"
        v-else
      >
        <ux-molecules-inspiration-filter-content
          :filters="filters"
          :legend="filtersTitle"
          @inspiration-filter-content::filter-update="filterUpdate"
          class="Inspiration-filter__dropdown"
        />
      </ux-molecules-modal-dropdown>
    </client-only>
  </div>
</template>
<script lang="ts" setup>
import { FiltersContent } from '../InspirationFilterContent/InspirationFilterContent.vue';

export interface InspirationFilterProps {
  filters?: FiltersContent[];
  filtersTitle?: string;
  label?: string;
}

const props = defineProps<InspirationFilterProps>();

const emit = defineEmits(['inspiration-filter::filter-update']);

const id = useId();
const { isTablet } = useCurrentWindowSize();
const filterModalIsOpen = ref<boolean>(false);
const modalTarget = ref<HTMLElement | null>(null);

const selectedFilters = computed(() => {
  return props.filters?.filter((f) => f.value === true).length;
});

const filterButtonAction = (event: Event) => {
  toggleFilterModal(event?.target as HTMLElement);
};

const toggleFilterModal = (targetElement: HTMLElement) => {
  modalTarget.value = targetElement;
  nextTick(() => {
    filterModalIsOpen.value = !filterModalIsOpen.value;
  });
};

const closeFilterModal = () => {
  filterModalIsOpen.value = false;
};

const filterUpdate = (filters: FiltersContent[]) => {
  emit('inspiration-filter::filter-update', filters);
};
</script>
<style lang="scss" scoped>
@use 'InspirationFilter.scss';
</style>
